// extracted by mini-css-extract-plugin
export default {"host":"MediaTable_host__eqBrh"};